import "../globalStyles/scss/index.scss";

import React from "react";

import { Footer, MainMenu, MetaConsumer, OverlayManager } from "../components";
import { Routes } from "./routes";

// AI Assistant
import AiAssistant from "../components/AiAssistant";

const App: React.FC = () => {
  return (
    <>
      <MetaConsumer />

      <header>
        <MainMenu />
      </header>

      <Routes />

      <Footer />

      <OverlayManager />

      {/* AI Assistant */}
      <AiAssistant />
    </>
  );
};

export default App;
